<template>
    <transition name="app-switcher-transition">
        <div class="app-context-switcher" v-show="visible">
            <div class="app-context-switcher__inner">
                <app-context-switcher-preview
                    v-for="(preview, index) in appHistory"
                    :key="index"
                    :preview="preview"
                    :tools="tools"
                    @click="() => switchContext(preview)"
                    :active="preview.stackId === currentStackId"
                    :id="preview.stackId"
                    :class="[preview.stackId === currentStackId ? activeClasses : '']"
                />
            </div>
        </div>
    </transition>
</template>

<script>
    import keymaster from 'keymaster';
    import AppSwitcherPreview from './AppSwitcherPreview';

    export default {
        mounted() {
            keymaster.setScope('app-switcher');
            keymaster.filter = () => true;
            keymaster('esc', () => {
                this.tools.actions.toggleContextSwitcher(false);
            });
        },
        data() {
            return {
                activeClasses: 'big',
                justCreatedClasses: '',
                currentStackId: null,
                visible: false,
                savedTransitionId: null,
            };
        },
        watch: {
            currentApp(val) {
                const stackIdUpdated = val.stackId !== this.currentStackId;
                const appStateHistory = this.currentApp.appStateHistory;

                if (this.tools.transitionId !== this.savedTransitionId && this.currentApp.oldStackId) {

                    // Fade in new element
                    setTimeout(() => {
                        const newlyAddedElement = document.getElementById(this.currentApp.stackId);
                        console.log('newly added element', newlyAddedElement);
                        newlyAddedElement.classList.add('is-hidden');
                    }, 25);

                    this.savedTransitionId = this.tools.transitionId;
                    this.currentStackId = this.currentApp.oldStackId;
                    // Make currently active big
                    this.activeClasses = 'big';
                    this.visible = true;
                    // Remove big
                    setTimeout(() => {
                        this.activeClasses = '';
                    }, 275);
                    setTimeout(() => {
                        this.currentStackId = this.currentApp.stackId;
                    }, 800);
                    // Set new stack ID
                    setTimeout(() => {
                        this.activeClasses = 'big';
                    }, 1100);
                    // Hide switcher
                    setTimeout(() => {
                        this.visible = false;
                    }, 1350);
                }
            },
            appHistory(appStateHistory) {
                if (appStateHistory.length === 1) {
                    this.currentStackId = this.currentApp.stackId;
                }
            },
            show(val) {
                // this.currentStackId = this.currentApp.stackId;
                this.activeClasses = 'big';
                if (val === true) {
                    setTimeout(() => {
                        this.activeClasses = '';
                    }, 300);
                    this.visible = val;
                } else {
                    this.activeClasses = 'big';
                    setTimeout(() => {
                        this.visible = false;
                    }, 300);
                }
            },
        },
        beforeDestroy() {
            keymaster.deleteScope('app-switcher');
        },
        name: 'app-context-switcher',
        props: ['tools', 'show', 'appHistory'],
        components: {
            'app-context-switcher-preview': AppSwitcherPreview,
        },
        computed: {
            currentApp() {
                return this.tools.currentApp;
            },
        },
        methods: {
            switchContext(preview) {
                this.currentStackId = preview.stackId;
                this.activeClasses = 'big';
                setTimeout(() => {
                    this.tools.actions.switchContext(preview);
                    this.visible = false;
                }, 200);
            },
        },
    };
</script>

<style>
    .app-context-switcher {
        position: absolute;
        top: 44px;
        left: 0;
        right: 0;
        z-index: 200;
        background: rgba(0,0,0,0.9);
        min-height: calc(100% - 44px);
        overflow: hidden;
    }
    .app-context-switcher__inner {
        display:flex;
        flex-flow: row wrap;
        justify-content:center;
        align-items:flex-start;
        padding:5vw 0 0 0;
    }

    .current-stack-id {
        color: #FFF;
        font-weight: bold;
        font-size: 40px;
    }

    .app-switcher-transition-enter-to {
        opacity:1;
        transition:opacity .15s;
    }
    .app-switcher-transition-leave {
        opacity:0;
        transition: opacity .2s;
    }
    .app-switcher-transition-enter,
    .app-switcher-transition-leave-to {
        opacity:0;
        transition: opacity .1s;
    }
</style>



// WEBPACK FOOTER //
// AppSwitcher.vue?7d8a5cca